import axiosInstance from "../utils/axios";

export const getAllAssessments = async (values) => {
  return await axiosInstance().post("/getAllAssignments", values);
};
